export const ENVIRONMENT = process.env.REACT_APP_ENV as string;
export const RECAPTCHA_ENABLED =
  process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' ? true : false;
export const GOOGLE_AUTH_ENABLED =
  process.env.REACT_APP_GOOGLE_AUTH_ENABLED === 'true' ? true : false;
export const APPLE_AUTH_ENABLED =
  process.env.REACT_APP_APPLE_AUTH_ENABLED === 'true' ? true : false;
export const ENABLE_TAX_FILE =
  process.env.REACT_APP_ENABLE_TAX_FILE === 'true' ? true : false;
export const RECAPTCHA_SITE_KEY = process.env
  .REACT_APP_RECAPTCHA_SITE_KEY as string;
export const API_URL = process.env.REACT_APP_API_URL as string;
export let SOCKET_URL = process.env.REACT_APP_SOCKET_URL as string;
export const SOCKET_INCOGNITO_URL = process.env
  .REACT_APP_SOCKET_INCOGNITO_URL as string;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL as string;
export const TAX1099_REDIRECT_URL = process.env.REACT_APP_TAX1099_APP_REDIRECT_URL as string;
export const GOOGLE_CLIENT_ID = process.env
  .REACT_APP_GOOGLE_CLIENT_ID as string;
export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID as string;
export const MSAL_ENABLED =
  process.env.REACT_APP_MSAL_ENABLED === 'true' ? true : false;

export const SALESFORCE_CLIENT_ID = process.env
  .REACT_APP_SALESFORCE_CLIENT_ID as string;
export const SALESFORCE_CLIENT_SECRET = process.env
  .REACT_APP_SALESFORCE_CLIENT_SECRET as string;
export const SALESFORCE_GRANT_TYPE = process.env
  .REACT_APP_SALESFORCE_GRANT_TYPE as string;

export const LOAD_STRIPE_KEY = process.env.REACT_APP_LOAD_STRIPE_KEY as string;

export const FORGOT_PASSWORD_CLIENT_DOMAIN = process.env
  .REACT_APP_FORGOT_PASSWORD_CLIENT_DOMAIN as string;

export const SESSION_EXPIRATION_TIME = parseInt(
  (process.env.REACT_APP_SESSION_EXPIRATION_TIME || '0') as string,
) as number;

export const ENABLE_SEND_FILE =
  process.env.REACT_APP_ENABLE_SEND_FILE === 'true' ? true : false;

export const SET_SOCKET_INCOGNITO_URL = () => {
  SOCKET_URL = SOCKET_INCOGNITO_URL;
};

export const GET_SOCKET_URL = () => {
  return SOCKET_URL;
};

export const S3_BUCKET = {
  ACCESS_KEY_ID: process.env.REACT_APP_S3_BUCKET_ACCESS_KEY_ID as string,
  ACCESS_KEY_SECRET: process.env
    .REACT_APP_S3_BUCKET_ACCESS_KEY_SECRET as string,
  REGION: process.env.REACT_APP_S3_BUCKET_REGION as string,
  NAME: process.env.REACT_APP_S3_BUCKET_NAME as string,
};

export const ALLOWED_FILE_TYPES = (
  process.env.REACT_APP_ALLOWED_FILE_TYPES as string
).split(',');

export const MAX_FILE_SIZE = parseInt(
  process.env.REACT_APP_MAX_FILE_SIZE as string,
);

export const PUBLIC_KEY_PEM =
  process.env.REACT_APP_PUBLIC_KEY_PEM as string;

export const INDEXED_DB = {
  NAME: process.env.REACT_APP_INDEXED_DB_NAME as string,
  VERSION: parseInt(
    (process.env.REACT_APP_INDEXED_DB_VERSION || '0') as string,
  ) as number,
};
